import React, { useState }  from 'react';
import './index.scss';
import { pathServer } from '../../../shared/constants/Constants';
import { Button } from '../../atoms';
import DropDown from '../../molecules/dropDown/DropDown';
import { DropzoneNewsLetter } from '../../molecules';

const ProductItemDetail = React.forwardRef(({className,onGoBack,listCategories,onSaveProduct, onChangeProduct, loadSave, productCreate ,onEditProduct,isEdit}, ref) => {

  const goBack = () => {
    onGoBack();
  };

  const onSave = async ()=>{
    try{
      if(isEdit){
        await onEditProduct()
        goBack();
      }else{
       await  onSaveProduct();
        goBack();
      }

    }catch (error){

    }
  };

  return (
    <div className="container-product-item" ref={ref}>
      <div className={`principal-container`}>
        <div className={`pc-left`}>
          <a href='#' onClick={goBack}><img src={`${pathServer.PATH_ICONS}icon_arrow_back.svg`} width="40%" alt="flecha atrás"/></a>
        </div>
        <div className={`pc-right`}>
          <h2>DETALLE DEL PRODUCTO</h2>
          <div className={`first-container d-flex`}>
            <div className={`fc_title`}>
              <div>
                <label>Nombre</label>
              </div>
              <input type='text' onChange={(e)=>onChangeProduct("title", e.target.value)} value={productCreate.title}/>
            </div>
          </div>
          <div className={`category-container`}>
            <div>
              <label>Categoría</label>
            </div>
            <DropDown
              options={listCategories}
              onSelectValue = {(e)=>onChangeProduct("idCategory", e.target.value)}
              selectedValue={productCreate.idCategory}
            />
          </div>
          <div className="paragraph-container">
            <div>
              <label>description</label>
            </div>
            <input type='text' onChange={(e)=>onChangeProduct("description", e.target.value)} value={productCreate.description}/>
          </div>
          <div className="preview-image-container">
            <label>Foto</label>
            <DropzoneNewsLetter selectFile={(file)=>onChangeProduct("photo",file)} isEdit={isEdit} imgEdit ={productCreate.photo}/>
          </div>
          <div className={`pl_button-container d-flex`}>
            <Button onClick={onSave} loading={loadSave}>Guardar</Button>
          </div>
        </div>
      </div>
    </div>
  );
});

ProductItemDetail.displayName = 'ProductItemDetail';

ProductItemDetail.defaultProps = {

};

ProductItemDetail.propTypes = {

};

export default ProductItemDetail;
